import React from 'react';
export function MechanismSection() {
  return <section className="py-24 px-4 bg-warm-bg" data-id="element-94">
      <div className="max-w-4xl mx-auto" data-id="element-95">
        <div className="text-center mb-16" data-id="element-96">
          <h2 className="text-4xl md:text-6xl font-black text-warm-dark mb-6" data-id="element-97">
            El Reset de 3 Minutos
          </h2>
          <p className="text-lg text-warm-mid max-w-2xl mx-auto" data-id="element-98">
            Una técnica de neuropsicología deportiva diseñada específicamente
            para cerebros en desarrollo.
          </p>
        </div>

        <p className="text-lg text-warm-mid leading-relaxed mb-16 text-center max-w-3xl mx-auto" data-id="element-99">
          En lugar de luchar contra la emoción, le enseña al niño a procesar el
          error como un "dato puramente técnico", realizar un anclaje físico y
          desconectar la respuesta de estrés en menos de 180 segundos para
          volver al juego con claridad.
        </p>

        <div className="grid md:grid-cols-3 gap-12" data-id="element-100">
          <div className="text-center space-y-4" data-id="element-101">
            <div className="font-heading text-5xl font-black text-warm-dark/20" data-id="element-102">
              01
            </div>
            <h3 className="font-heading font-bold text-xl text-warm-dark" data-id="element-103">
              Procesa el Error
            </h3>
            <p className="text-warm-mid text-sm leading-relaxed" data-id="element-104">
              Transforma la falla emocional en un dato técnico objetivo.
            </p>
          </div>

          <div className="text-center space-y-4" data-id="element-105">
            <div className="font-heading text-5xl font-black text-warm-dark/20" data-id="element-106">
              02
            </div>
            <h3 className="font-heading font-bold text-xl text-warm-dark" data-id="element-107">
              Anclaje Físico
            </h3>
            <p className="text-warm-mid text-sm leading-relaxed" data-id="element-108">
              Utiliza el cuerpo para interrumpir el patrón de pensamiento
              negativo.
            </p>
          </div>

          <div className="text-center space-y-4" data-id="element-109">
            <div className="font-heading text-5xl font-black text-warm-dark/20" data-id="element-110">
              03
            </div>
            <h3 className="font-heading font-bold text-xl text-warm-dark" data-id="element-111">
              Menos de 180s
            </h3>
            <p className="text-warm-mid text-sm leading-relaxed" data-id="element-112">
              Desconecta el estrés y vuelve al juego con total claridad mental.
            </p>
          </div>
        </div>
      </div>
    </section>;
}